import { type AxiosError } from 'axios'

/**
 * Use custom function instead of `isAxiosError` from `axios` to avoid compilation warnings
 * during `middleware` build (uses `Edge Runtime`).
 *
 * Remove after migration to Node.js runtime for `middleware`.
 */
export const apmIsAxiosError = (error: Error): error is AxiosError =>
  'isAxiosError' in error && error.isAxiosError === true
